import { ErrorMessage, Formik } from 'formik'
import { ComponentType } from 'react'
import { Button, FormFeedback, FormGroup, Input, Label } from 'reactstrap'
import styled from 'styled-components'
import * as Yup from 'yup'

const FormInput = styled(Input)`
  height: auto;
  font-size: 15px;
  line-height: 18px;
  letter-spacing: 0.5px;
  padding: 15px 16px;
`

const FORM_SCHEMA = Yup.object().shape({
  property: Yup.string().required('Campo requerido'),
  name: Yup.string().required('Campo requerido'),
  city: Yup.string().required('Campo requerido'),
  phone: Yup.string().required('Campo requerido'),
  email: Yup.string().email('Ingresa un email válido').required('Campo requerido'),
  message: Yup.string(),
})

interface LeadFormProps {
  propertyId: any
  loading: boolean
  onSubmit: (values: any) => void
}

export const Form: ComponentType<LeadFormProps> = ({ propertyId, loading, onSubmit }) => (
  <Formik
    initialValues={{
      property: propertyId,
      name: '',
      city: '',
      phone: '',
      email: '',
      message: '',
    }}
    validationSchema={FORM_SCHEMA}
    onSubmit={(values) => onSubmit(values)}
  >
    {({ values, errors, touched, handleBlur, handleChange, handleSubmit }) => (
      <form onSubmit={handleSubmit}>
        <h5 className="mb-25 font-family-serif font-size-17 font-weight-bold">Solicita más información</h5>
        <p className="mb-30 font-size-15">
          Completa el formulario y obtén atención personalizada de un Asesor Certificado.
        </p>
        <FormGroup className="mb-20">
          <Label htmlFor="name" className="pl-15 mb-12 text-trout font-weight-bold font-size-15">
            Nombre completo
          </Label>
          <FormInput
            id="name"
            name="name"
            bsSize="lg"
            value={values.name}
            invalid={Boolean(errors.name && touched.name)}
            onBlur={handleBlur}
            onChange={handleChange}
          />
          <ErrorMessage name="name" component={FormFeedback} />
        </FormGroup>
        <FormGroup className="mb-20">
          <Label htmlFor="city" className="pl-15 mb-12 text-trout font-weight-bold font-size-15">
            Ciudad de origen
          </Label>
          <FormInput
            id="city"
            name="city"
            bsSize="lg"
            value={values.city}
            invalid={Boolean(errors.city && touched.city)}
            onBlur={handleBlur}
            onChange={handleChange}
          />
          <ErrorMessage name="city" component={FormFeedback} />
        </FormGroup>
        <FormGroup className="mb-20">
          <Label htmlFor="phone" className="pl-15 mb-12 text-trout font-weight-bold font-size-15">
            Teléfono de contacto
          </Label>
          <FormInput
            id="phone"
            name="phone"
            bsSize="lg"
            value={values.phone}
            invalid={Boolean(errors.phone && touched.phone)}
            onBlur={handleBlur}
            onChange={handleChange}
          />
          <ErrorMessage name="phone" component={FormFeedback} />
        </FormGroup>
        <FormGroup className="mb-20">
          <Label htmlFor="email" className="pl-15 mb-12 text-trout font-weight-bold font-size-15">
            Email
          </Label>
          <FormInput
            id="email"
            name="email"
            bsSize="lg"
            value={values.email}
            invalid={Boolean(errors.email && touched.email)}
            onBlur={handleBlur}
            onChange={handleChange}
          />
          <ErrorMessage name="email" component={FormFeedback} />
        </FormGroup>
        <FormGroup className="mb-20">
          <Label htmlFor="message" className="pl-15 mb-12 text-trout font-weight-bold font-size-15">
            Mensaje
          </Label>
          <FormInput
            rows={3}
            type="textarea"
            id="message"
            name="message"
            bsSize="lg"
            value={values.message}
            invalid={Boolean(errors.message && touched.message)}
            onBlur={handleBlur}
            onChange={handleChange}
          />
          <ErrorMessage name="message" component={FormFeedback} />
        </FormGroup>
        <Button type="submit" color="primary" size="lg" disabled={loading} block>
          {loading ? 'Enviando solicitud...' : 'Enviar solicitud'}
        </Button>
      </form>
    )}
  </Formik>
)
